import MenuItem from '@mui/material/MenuItem';

const menuOption = (item: { id: string, name: string }) =>
	<MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>

const NoneOption = <MenuItem key='None' value=''><em>None</em></MenuItem>;

export const menuOptions = (items: { id: string, name: string }[], withEmptyOption?: boolean) => {
	const options = items.map((item) => menuOption(item));
	if (withEmptyOption) {
		options.unshift(NoneOption);
	}
	return options;
}
